import { __decorate } from "tslib";
import { AsnIntegerArrayBufferConverter, AsnProp, AsnPropTypes } from "@peculiar/asn1-schema";
import { Extensions } from "@peculiar/asn1-x509";
import { MessageImprint } from "./message_imprint";
export var TimeStampReqVersion;
(function (TimeStampReqVersion) {
    TimeStampReqVersion[TimeStampReqVersion["v1"] = 1] = "v1";
})(TimeStampReqVersion || (TimeStampReqVersion = {}));
export class TimeStampReq {
    constructor(params = {}) {
        this.version = TimeStampReqVersion.v1;
        this.messageImprint = new MessageImprint();
        this.certReq = false;
        Object.assign(this, params);
    }
}
__decorate([
    AsnProp({ type: AsnPropTypes.Integer })
], TimeStampReq.prototype, "version", void 0);
__decorate([
    AsnProp({ type: MessageImprint })
], TimeStampReq.prototype, "messageImprint", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.ObjectIdentifier, optional: true })
], TimeStampReq.prototype, "reqPolicy", void 0);
__decorate([
    AsnProp({
        type: AsnPropTypes.Integer,
        converter: AsnIntegerArrayBufferConverter,
        optional: true,
    })
], TimeStampReq.prototype, "nonce", void 0);
__decorate([
    AsnProp({ type: AsnPropTypes.Boolean, defaultValue: false })
], TimeStampReq.prototype, "certReq", void 0);
__decorate([
    AsnProp({ type: Extensions, optional: true, context: 0, implicit: true })
], TimeStampReq.prototype, "extensions", void 0);
